import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { SaveAbortLineComponent } from './save-abort-line.component';

@NgModule({
    declarations: [
        SaveAbortLineComponent, //
    ],
    exports: [
        SaveAbortLineComponent, //
    ],
    imports: [
        CommonModule, //
        MatIconModule,
    ],
})
export class SaveAbortLineModule {}
